import $ from "jquery";
import Swiper from "swiper";
import { Navigation, Pagination, A11y, Keyboard } from "swiper/modules";

// ====================================================================================
// CSS
let css =
  "/typo3conf/ext/as_template/Resources/Public/StyleSheets/Vendor/swiper-bundle.min.css";
if ($('[href="' + css + '"]').length === 0) {
  $("head").append(
    '<link rel="stylesheet" type="text/css" href="' + css + '">'
  );
}
// ====================================================================================

export const init = function () {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      $(".banner-swiper-container").each(function (index) {
        let $this = $(this);
        let cID = $this.attr("id");
        let id = $this.find(".swiper").attr("id");

        let c3Slider = new Swiper(`#${id}`, {
          modules: [Navigation, Pagination, Keyboard, A11y],
          loop: true,
          speed: 500,
          navigation: {
            nextEl: `#${cID} .swiper-button-next`,
            prevEl: `#${cID} .swiper-button-prev`,
          },
          pagination: {
            el: `#${cID} .swiper-pagination`,
            type: "bullets",
            clickable: true,
          },
          keyboard: {
            enabled: true,
          },
          a11y: {
            enabled: true,
          },
          on: {
            afterInit: function (slider) {
              $(`#${cID}`).addClass("slider-init");
            },
          },
        });
      });
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
